// useBlogData.js (Custom Hook)
import { useState, useEffect } from 'react';
import { ApiUrl } from '../utils/Api';
import { CAT_NAME } from '../utils/constant';

const useBlogData = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [posts, setPosts] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const fetchPosts = async (categoryId = null) => {
        setLoading(true);
        try {
            const categoryFilter = categoryId ? `&categories=${categoryId}` : '';
            const response = await fetch(`${ApiUrl}posts?per_page=11&page=${page}${categoryFilter}`);
            if (!response.ok) {
                throw new Error("Failed to fetch posts");
            }

            const data = await response.json();
            if (data.length < 11) {
                setHasMore(false);
            }
            setPosts(prevPosts => page === 1 ? data : [...prevPosts, ...data]);
        } catch (error) {
            console.error("Error fetching posts:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts(selectedCategory);
    }, [page, selectedCategory]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${ApiUrl}categories`);
                if (!response.ok) {
                    throw new Error("Failed to fetch categories");
                }
                const data = await response.json();
                setCategories(data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    const resetPosts = (id) => {
        if (selectedCategory !== id){ // to prevent calling again same category
            setPosts([]);
            setPage(1);
            setHasMore(true);
        }
       
    };

    return {
        categories,
        loading,
        posts,
        page,
        hasMore,
        selectedCategory,
        setPage,
        setSelectedCategory,
        resetPosts,
        CAT_NAME,
    };
};

export default useBlogData;